import * as React from 'react'
import Button from '@mui/material/Button'
import CssBaseline from '@mui/material/CssBaseline'
import TextField from '@mui/material/TextField'
import Box from '@mui/material/Box'
import Container from '@mui/material/Container'
import UserLayout from '../layouts/UserLayout'
import axios from 'axios'
import { api } from '../utils/api'
import { getFromStorage } from '../utils/storage'
import { handleError } from '../utils/error'
import { useNavigate } from 'react-router-dom'
import { Card, FormControl, IconButton, InputAdornment, InputLabel, OutlinedInput } from '@mui/material'
import Visibility from '@mui/icons-material/Visibility'
import VisibilityOff from '@mui/icons-material/VisibilityOff'
import { useDispatch } from 'react-redux'
import { currentUserActions } from '../redux/store'
import { mainGreen } from '../utils/color'

export default function ChangePassword() {
	const dispatch = useDispatch()
	const navigate = useNavigate()
	const token = getFromStorage('current-user')?.accessToken
	const [showPassword, setShowPassword] = React.useState(false)

	const handleClickShowPassword = () => setShowPassword((show) => !show)
	const oldPwRef = React.useRef()
	const newPwRef = React.useRef()

	const handleSubmit = async (event) => {
		event.preventDefault()
		const oldPassword = oldPwRef.current.value
		const newPassword = newPwRef.current.value

		const regexPassword = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/
		if (!regexPassword.test(newPassword)) {
			alert('Mật khẩu mới tối thiểu 8 ký tự, 1 ký tự in hoa, 1 ký tự thường, 1 chữ số, 1 ký tự đặc biệt!')
			return
		}

		try {
			const response = await axios({
				method: 'POST',
				url: api.CHANGE_PASSWORD,
				headers: {
					Authorization: `Bearer ${token}`,
				},
				data: { oldPassword, newPassword },
			})
			alert(response.data.message)
		} catch (error) {
			handleError(error)
			dispatch(currentUserActions.isLogout())
			navigate('/login')
		}
	}

	return (
		<UserLayout>
			<Container sx={{ marginTop: '20px', padding: 0 }} maxWidth='sm'>
				<CssBaseline />
				<Card
					sx={{
						display: 'flex',
						flexDirection: 'column',
						alignItems: 'center',
						padding: '20px',
					}}>
					<Box component='form' onSubmit={handleSubmit} noValidate sx={{ m: 0 }}>
						<TextField
							inputRef={oldPwRef}
							type='password'
							margin='normal'
							fullWidth
							label='Mật khẩu cũ'
							autoComplete='password'
							autoFocus
						/>
						<FormControl fullWidth sx={{ mt: 2 }}>
							<InputLabel htmlFor='outlined-adornment-password'>Mật khẩu mới</InputLabel>
							<OutlinedInput
								inputRef={newPwRef}
								sx={{ pr: 2 }}
								id='outlined-adornment-password'
								type={showPassword ? 'text' : 'password'}
								autoComplete='password'
								autoFocus
								endAdornment={
									<InputAdornment position='end'>
										<IconButton aria-label='toggle password visibility' onClick={handleClickShowPassword} edge='end'>
											{showPassword ? <Visibility /> : <VisibilityOff />}
										</IconButton>
									</InputAdornment>
								}
								label='Mật khẩu mới'
								required
							/>
						</FormControl>

						<Button
							type='submit'
							fullWidth
							variant='contained'
							sx={{
								mt: 2,
								background: mainGreen,
								'&:hover': { background: mainGreen },
							}}>
							Đổi mật khẩu
						</Button>
					</Box>
				</Card>
			</Container>
		</UserLayout>
	)
}
